import { axiosWrapper } from "../../axiosWrapper";
import { CustomerAccountDetail } from "../../models/Accounts/IAccountDetail";

export class AccountDetailService {
    public static async getAccountDetail(id: string) {
        return await axiosWrapper.Get("Accounts/CustomerAccountDetail/" + id);
    }

    public static async CustomerAccountUpdate(accountData: CustomerAccountDetail) {
        return await axiosWrapper.Post("Accounts/UpdateCustomerAccount", accountData);
    }
}